module.exports = __webpack_public_path__ + "static/media/sontho-4.61c5af67.png";